import * as React from 'react';
import './NotSet.css';

/**
 * 詳細の表示で、値が設定されていない項目に出す「未設定」。実際の値と見分けられるよう、薄い灰色の文字で出す。
 * 一覧の表の中の空のセルは、表として見比べやすいよう空欄のままにし、この表示は使わない。
 */
export const NotSet: React.FC = function () {
  return <span className="NotSet">未設定</span>;
};

/** 文字の値を、空（未設定・空白だけ）なら「未設定」、そうでなければそのまま出す */
export function textOrNotSet(value: string | null | undefined): React.ReactNode {
  if (value === null || value === undefined || value.trim() === '') {
    return <NotSet />;
  }
  return value;
}
